import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import moment from 'moment';
import * as Papa from 'papaparse';
import firebase from 'firebase/app';

require("firebase/firestore");
const FileSaver = require('file-saver');

const styles = theme => ({
  table: {
    width: '100%',
    display: 'table',
    tableLayout: 'fixed',
  },
  row: {
    display: 'table-row',
  },
  cell: {
    display: 'table-cell',
  },
  card: {
    padding: 16,
  },
  marginLeft: {
    marginLeft: 16,
  },
});

class ExportPage extends Component {
  state = {
    dt_type: "all", // range
    dt_from: moment().subtract(1, 'months').toDate(),
    dt_to: moment().toDate(),

    pt_type: "all", // range
    pt_from: moment().subtract(1, 'months').toDate(),
    pt_to: moment().toDate(),

    monthly_member_date: moment().toDate(),
    monthly_member_count: 0,
  };

  handleExportCustomer = () => {
    this.startProcessing();

    var users = this.props.users;
    if (users.length > 0) {
      for (var i = 0; i < users.length; i++) {
        var user = users[i];

        user.name = user.name || "";
        user.email = user.email || "";
        user.phone = user.phone || "";
        user.gender = user.gender || "";
        user.occupation = user.occupation || "";
        user.dob = user.dob && moment(user.dob.toDate()).format("DD/MM/YYYY");
        user.registerDate = user.registerDate && moment(user.registerDate.toDate()).format("DD/MM/YYYY kk:mm:ss");
        user.registrationBranch = user.registrationBranch || "";
        user.howToKnow_facebook = (user.howToKnow && user.howToKnow.includes('facebook')) || false;
        user.howToKnow_instagram = (user.howToKnow && user.howToKnow.includes('instagram')) || false;
        user.howToKnow_friend = (user.howToKnow && user.howToKnow.includes('friend')) || false;
        user.howToKnow_google = (user.howToKnow && user.howToKnow.includes('google')) || false;
        user.howToKnow_sponsorship = (user.howToKnow && user.howToKnow.includes('sponsorship')) || false;
        user.visitCount = user.visitCount || "";
        user.lastVisitedDateTime = user.lastVisitedDateTime && moment(user.lastVisitedDateTime.toDate()).format("DD/MM/YYYY");

        users[i] = user;
      }
    }

    var csv = Papa.unparse(users);
    var blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
    FileSaver.saveAs(blob, "customers.csv");

    this.stopProcessing();
  }

  handleCalculateCurrentMonthlyMembers = () => {
    this.startProcessing();

    firebase.firestore()
      .collection('userPasses')
      .where("expiryDate", ">=", moment(this.state.monthly_member_date).endOf('day').toDate())
      .get()
      .then(qs => {
        this.setState({ monthly_member_count: qs.size });
        this.stopProcessing();
      });
  }

  handleExportDeskTransaction = () => {
    this.startProcessing();

    var fileSuffix = "full";
    var query = firebase.firestore().collection('deskTransaction');

    if (this.state.dt_type === "range") {
      var mFrom = moment(this.state.dt_from).startOf('day');
      var mTo = moment(this.state.dt_to).endOf('day');

      fileSuffix = mFrom.format("YYYYMMDD") + "_to_" + mTo.format("YYYYMMDD");

      query = query
        .where('checkInTime', '>=', mFrom.toDate())
        .where('checkInTime', '<=', mTo.toDate());
    }

    query
      .orderBy("checkInTime", "desc")
      .get()
      .then(querySnapshot => {
        var transactions = [];

        querySnapshot.forEach(doc => {
          var transaction = doc.data();

          if (!transaction.voided) {
            transaction.checkInTime = transaction.checkInTime && moment(transaction.checkInTime.toDate()).format("DD/MM/YYYY kk:mm:ss");
            transaction.checkOutTime = transaction.checkOutTime && moment(transaction.checkOutTime.toDate()).format("DD/MM/YYYY kk:mm:ss");

            transactions.push(transaction);
          }
        });

        var csv = Papa.unparse({
          fields: [
            "branch",
            "userId",
            "checkInTime",
            "checkOutTime",
            "paymentAmount",
            "suggestedAmount",
            "paymentAmount",
            "paymentMethod",
            "extraService",
            "extraServiceFee",
            "passTransactionId",
            "passUsed",
            "remark",
            "staffRemark",
            "isFirstCome",
          ],
          data: transactions,
        });
        var blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
        FileSaver.saveAs(blob, "desk_transactions_" + fileSuffix + ".csv");

        this.stopProcessing();
      });
  }

  handleExportPassTransactions = () => {
    this.startProcessing();

    var fileSuffix = "full";
    var query = firebase.firestore().collection('passTransaction');

    if (this.state.pt_type === "range") {
      var mFrom = moment(this.state.pt_from).startOf('day');
      var mTo = moment(this.state.pt_to).endOf('day');

      fileSuffix = mFrom.format("YYYYMMDD") + "_to_" + mTo.format("YYYYMMDD");

      query = query
        .where('transactionDate', '>=', mFrom.toDate())
        .where('transactionDate', '<=', mTo.toDate());
    }

    query
      .orderBy("transactionDate", "desc")
      .get()
      .then(querySnapshot => {
        var transactions = [];

        querySnapshot.forEach(doc => {
          var transaction = doc.data();

          transaction.transactionDate = transaction.transactionDate && moment(transaction.transactionDate.toDate()).format("DD/MM/YYYY kk:mm:ss");

          transactions.push(transaction);
        });

        var csv = Papa.unparse({
          fields: [
            "branch",
            "userId",
            "passId",
            "adjustment",
            "paymentAmount",
            "transactionDate",
            "staffRemark",
            "isFirstTimeBuy",
          ],
          data: transactions,
        });
        var blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
        FileSaver.saveAs(blob, "pass_transactions_" + fileSuffix + ".csv");

        this.stopProcessing();
      });
  }

  startProcessing = () => {
    this.setState({ processing: true });
  }

  stopProcessing = () => {
    this.setState({ processing: false });
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        <div className={classes.table}>
          <div className={classes.row}>

            <div key="users" className={classes.cell}>
              <Card>
                <CardContent>
                  <Typography variant="h5" component="h2">
                    All Customers
                  </Typography>
                </CardContent>
                <CardActions>
                  <Button
                    size="small"
                    color="primary"
                    disabled={this.state.processing}
                    onClick={this.handleExportCustomer}>
                    EXPORT
                  </Button>
                </CardActions>
              </Card>

              <Card style={{ marginTop: 16 }}>
                <CardContent>
                  <Typography variant="h5" component="h2">
                    Monthly members: {this.state.monthly_member_count}
                  </Typography>
                  <TextField
                    fullWidth
                    margin="normal"
                    type="date"
                    InputLabelProps={{ shrink: true, }}
                    label="Date"
                    value={this.state.monthly_member_date ? moment(this.state.monthly_member_date).format('YYYY-MM-DD') : ""}
                    onChange={event => this.setState({ monthly_member_date: event.target.value ? moment(event.target.value, 'YYYY-MM-DD').toDate() : null })}
                  />
                </CardContent>
                <CardActions>
                  <Button
                    size="small"
                    color="primary"
                    onClick={this.handleCalculateCurrentMonthlyMembers}>
                    Calculate
                  </Button>
                </CardActions>
              </Card>
            </div>

            <div key="deskTransactions" className={classes.cell}>
              <Card className={classes.marginLeft}>
                <CardContent>
                  <Typography variant="h5" component="h2">
                    Desk Transactions
                  </Typography>

                  <FormControl fullWidth margin="normal" >
                    <InputLabel>Selection</InputLabel>
                    <Select
                      value={this.state.dt_type}
                      onChange={event => this.setState({ dt_type: event.target.value })} >
                      <MenuItem value="all">All</MenuItem>
                      <MenuItem value="range">Date Range</MenuItem>
                    </Select>
                  </FormControl>

                  {
                    this.state.dt_type === "range" ?
                      <div>
                        <TextField
                          fullWidth
                          margin="normal"
                          type="date"
                          InputLabelProps={{ shrink: true, }}
                          label="From"
                          value={this.state.dt_from ? moment(this.state.dt_from).format('YYYY-MM-DD') : ""}
                          onChange={event => this.setState({ dt_from: event.target.value ? moment(event.target.value, 'YYYY-MM-DD').toDate() : null })}
                        />
                        <TextField
                          fullWidth
                          margin="normal"
                          type="date"
                          InputLabelProps={{ shrink: true, }}
                          label="To"
                          value={this.state.dt_to ? moment(this.state.dt_to).format('YYYY-MM-DD') : ""}
                          onChange={event => this.setState({ dt_to: event.target.value ? moment(event.target.value, 'YYYY-MM-DD').toDate() : null })}
                        />
                      </div>
                      : null
                  }

                </CardContent>
                <CardActions>
                  <Button
                    size="small"
                    color="primary"
                    disabled={
                      this.state.processing ||
                      (this.state.dt_type === "range" && (!this.state.dt_from || !this.state.dt_to || moment(this.state.dt_from).isAfter(this.state.dt_to, 'day')))
                    }
                    onClick={this.handleExportDeskTransaction}>
                    EXPORT
                  </Button>
                </CardActions>
              </Card>
            </div>

            <div key="passTransactions" className={classes.cell}>
              <Card className={classes.marginLeft}>
                <CardContent>
                  <Typography variant="h5" component="h2">
                    Pass Transactions
                  </Typography>

                  <FormControl
                    fullWidth
                    margin="normal" >
                    <InputLabel>Selection</InputLabel>
                    <Select
                      value={this.state.pt_type}
                      onChange={event => this.setState({ pt_type: event.target.value })} >
                      <MenuItem value="all">All</MenuItem>
                      <MenuItem value="range">Date Range</MenuItem>
                    </Select>
                  </FormControl>

                  {
                    this.state.pt_type === "range" ?
                      <div>
                        <TextField
                          fullWidth
                          margin="normal"
                          type="date"
                          InputLabelProps={{ shrink: true, }}
                          label="From"
                          value={this.state.pt_from ? moment(this.state.pt_from).format('YYYY-MM-DD') : ""}
                          onChange={event => this.setState({ pt_from: event.target.value ? moment(event.target.value, 'YYYY-MM-DD').toDate() : null })}
                        />
                        <TextField
                          fullWidth
                          margin="normal"
                          type="date"
                          InputLabelProps={{ shrink: true, }}
                          label="To"
                          value={this.state.pt_to ? moment(this.state.pt_to).format('YYYY-MM-DD') : ""}
                          onChange={event => this.setState({ pt_to: event.target.value ? moment(event.target.value, 'YYYY-MM-DD').toDate() : null })}
                        />
                      </div>
                      : null
                  }

                </CardContent>
                <CardActions>
                  <Button
                    size="small"
                    color="primary"
                    disabled={
                      this.state.processing ||
                      (this.state.pt_type === "range" && (!this.state.pt_from || !this.state.pt_to || moment(this.state.pt_from).isAfter(this.state.pt_to, 'day')))
                    }
                    onClick={this.handleExportPassTransactions}>
                    EXPORT
                  </Button>
                </CardActions>
              </Card>
            </div>

          </div>
        </div>
      </div>
    );
  }

}

ExportPage.propTypes = {
  classes: PropTypes.object.isRequired,
  users: PropTypes.array.isRequired,
};

export default withStyles(styles)(ExportPage);
